import React, { FC, PropsWithChildren } from "react";
import style from "./style.scss";
import { Accordion } from "@xapp/components";

export interface ThemeBuilderSectionProps {
    /**
     * Title of the section
     */
    readonly heading: string;
    /**
     * Optional class name
     */
    readonly className?: string;
    /**
     * Use an accordian to hide the section
     */
    readonly accordian?: boolean;
}

export const ThemeBuilderSection: FC<PropsWithChildren<ThemeBuilderSectionProps>> = props => {
    return (
        <>
            {props.accordian ? (
                <Accordion title={<p className={style.sectionAccordianHeader}>{props.heading}</p>} className={style.section + " widget-theme-builder-section " + (props.className ?? "")}>
                    {props.children ?? <></>}
                </Accordion>
            ) : (
                <div className={style.section + " widget-theme-builder-section " + (props.className ?? "")}>
                    {props.heading && (
                        <p className={style.sectionHeader + " widget-theme-builder-section--heading"}>
                            {props.heading}
                        </p>
                    )}
                    <div className={style.sectionContent}>
                        {props.children}
                    </div>
                </div >
            )}
        </>
    );
};
